import { getHeaders } from './helpers';

const ImageApi = {
  cache: {},
  keys: [],

  async getImage(imageUrl) {
    if (typeof imageUrl !== 'string') {
      console.warn('Invalid imageUrl:', imageUrl);
      return '';
    }

    const fullImageUrl = imageUrl.startsWith('http') ? imageUrl : `https://${imageUrl}`;

    if (fullImageUrl in this.cache) return this.cache[fullImageUrl];

    const request = new Request(fullImageUrl, {
      method: 'GET',
      headers: getHeaders(),
    });

    const stream = await fetch(request);
    const blob = await stream.blob();
    const image = URL.createObjectURL(blob);

    this.addToCache(fullImageUrl, image);

    return image;
  },

  addToCache(imageUrl, image) {
    if (typeof imageUrl !== 'string') {
      console.warn('Invalid imageUrl:', imageUrl);
      return '';
    }

    const fullImageUrl = imageUrl.startsWith('http') ? imageUrl : `https://${imageUrl}`;

    this.cache[fullImageUrl] = image;
    this.keys.push(imageUrl);

    // Keep only latest 50 images
    if (this.keys.length <= 50) return;

    const keyToDelete = this.keys.shift();
    delete this.cache[keyToDelete];
  },
};

export default ImageApi;
